import { FC } from 'react'

import Icon, { IconName } from 'project/Icon'

type CardTitleProps = {
  children: string
  icon?: IconName
}

const CardTitle: FC<CardTitleProps> = ({ children, icon }) => {
  return (
    <div className='d-flex align-items-center gap-2 mb-5'>
      {icon && <Icon name={icon} fill='body' />}
      <span className='fw-bold fs-lg'>{children}</span>
    </div>
  )
}

export default CardTitle
